export function getErrorCodeFromPayload(payload: unknown): string | undefined {
  if (typeof payload !== "object" || payload === null || !("code" in payload)) return undefined

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const { code } = payload as { code?: unknown }
  return typeof code === "string" ? code : undefined
}
